import { FsStatus } from './utilityClasses';

export class FsSelectorPeriod {
  period: Date;
  status: FsStatus;
  iconNameAndStyling1?: string;

  constructor(period: Date, status: FsStatus) {
    this.period = period;
    this.setStatusAndIcon(status);
  }

  setStatusAndIcon(status: FsStatus): void {
    this.status = status;
    switch (status) {
      case FsStatus.none:
        this.iconNameAndStyling1 = '';
        break;
      case FsStatus.started:
        this.iconNameAndStyling1 = 'lock-opened-empty.svg';
        break;
      case FsStatus.completed:
        this.iconNameAndStyling1 = 'lock-closed-fill.svg';
        break;
    }
  }

  changeStatusAndIconAndReturnNew(status: FsStatus): FsSelectorPeriod {
    this.status = status;
    switch (status) {
      case FsStatus.none:
        this.iconNameAndStyling1 = '';
        break;
      case FsStatus.started:
        this.iconNameAndStyling1 = 'lock-opened-empty.svg';
        break;
      case FsStatus.completed:
        this.iconNameAndStyling1 = 'lock-closed-fill.svg';
        break;
    }
    return new FsSelectorPeriod(this.period, this.status);
  }
}
